import React, { useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { QuestionTitle } from "../questionTitlte/QuestionTitle";
import { style as hostRankQuestionItemStyle } from "./HostRankQuestionItem.style";
const HostRankQuestionItem = ({ domain, question, level, children, segment }) => {
    const rankMinDescription = useI18nMessage({
        domain,
        id: question.metadata.minTranslationKey,
        values: { segment: segment.toLowerCase() },
    });
    const rankMaxDescription = useI18nMessage({
        domain,
        id: question.metadata.maxTranslationKey,
        values: { segment: segment.toLowerCase() },
    });
    const style = useMemo(() => hostRankQuestionItemStyle(), []);
    return (React.createElement(View, { style: style.container, testID: "host-rank-question-item" },
        React.createElement(QuestionTitle, { domain: domain, level: level, segment: segment, translationKey: question.translationKey }),
        children,
        React.createElement(View, { style: style.rankDescription },
            React.createElement(Text, { level: 3, style: style.rankDescriptionText, variant: "detail" }, rankMinDescription),
            React.createElement(Text, { level: 3, style: style.rankDescriptionText, variant: "detail" }, rankMaxDescription))));
};
export { HostRankQuestionItem };
